module.exports = __webpack_public_path__ + "img/endereco_servico.589ca0f0.svg";